module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-08d52ad13f3d00bbd8b3154b8a4b24e9.png";